module.exports = require("uncontrollable");


//////////////////
// WEBPACK FOOTER
// external "uncontrollable"
// module id = 9
// module chunks = 0